<template>
    <div class="customer-members">
        <router-link
            class="button button--thick button--big button--outlined button--icon"
            :to="membersRoute"
        >
            <IconUsers fill="#ff6b06" class="button__icon" />

            <span v-if="membersCount" class="customer__members-count">
                Members ({{ membersCount }})
            </span>
            <span v-else v-t="'crm.customers.members.list.empty'" />
        </router-link>
    </div>
</template>

<script>
import { fetchCustomersMembers } from '../../api/customers';
import { IconUsers } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'CustomerMembers',
    components: {
        IconUsers,
    },
    props: {
        customerId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            membersCount: 0,
        };
    },
    computed: {
        membersCountPlural() {
            const { membersCount: n } = this;
            return this.$t('crm.customers.members.item', n, { n });
        },
        membersRoute() {
            return {
                name: 'customers-members',
                query: {
                    customer_id: this.customerId,
                },
            };
        },
    },
    async created() {
        try {
            await this.fetchCustomersMembers();
        } catch (err) {
            console.log(err);
        }
    },
    methods: {
        async fetchCustomersMembers() {
            const params = {
                customer_id: this.customerId,
                page_size: 9999,
            };
            const { count } = await fetchCustomersMembers(params);
            this.membersCount = count;
        },
    },
};
</script>
